import React from 'react';
import { Input } from 'semantic-ui-react';
import { formatCurrency } from '../../helpers/payDuties';

const PayForm = ({ parcelData, fields, onChangeInput, errors }) => {
  const buyer = parcelData.buyer;
  const address = `${buyer.address.zip}, ${buyer.address.stAddress}, ${buyer.address.city}, ${buyer.address.country}`;
  const localCurrency = parcelData.duties.localCurrency;

  return (
    <div className='animated fadeIn'>
      <div className='section bold'>
        לקוח/ה יקר/ה,
        לצורך שחרור מהמכס של המוצר שהזמנת נדרשים פרטי ת.ז ותשלום מע״מ ואגרות.
      </div>
      <div className='section'>
        <div className='details'>
          <label>
            סכום לתשלום:
          </label>
          <div className='value bold'>
            {formatCurrency(localCurrency.payments.total, localCurrency.currencyCode)}
          </div>
        </div>
      </div>
      <div className='section'>
        <div className='title bold'>
          פרטי הנמען:
        </div>
        {buyer.isIDNeeded &&
          <div className='details'>
            <label htmlFor='id_number' className='red'>
              *ת״ז:
            </label>
            <Input
              placeholder='הזינו תעודת זהות'
              value={fields.buyerID || ''}
              name='buyerID'
              required={buyer.isIDNeeded}
              onChange={onChangeInput}
            />
          </div>}
        {errors.buyerID &&
          <div className='error-message animated fadeIn'>{errors.buyerID}
          </div>}
        <div className='details'>
          <label htmlFor='email' className='red'>
            *דוא״ל
          </label>
          <Input
            placeholder=' הזינו מייל '
            value={fields.email || ''}
            name='email'
            required
            onChange={onChangeInput}
          />
        </div>
        {errors.email &&
          <div className='error-message animated fadeIn'>{errors.email}
          </div>}
        <div className='details'>
          <label>
            שם:
          </label>
          <div className='value'>
            {buyer.name}
          </div>
        </div>
        <div className='details'>
          <label>
            כתובת:
          </label>
          <div className='value'>
            {address}
          </div>
        </div>
      </div>
      <div className='section'>
        <div className='title bold'>
          פרטי המוצר:
        </div>
        <div className='details'>
          <label>
            מספר מעקב:
          </label>
          <div className='value'>
            {parcelData.hawb}
          </div>
        </div>
        <div className='details'>
          <label>
            תיאור הפריט:
          </label>
          <div className='value'>
            {parcelData.description}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PayForm;
